import React from 'react'
import {Link} from 'react-router-dom'

import {Helmet} from 'react-helmet'

import { store } from '../../store'

import {Grid, Row, Col, FormControl} from 'react-bootstrap'

const initialState = {
  url: '',
  check: 'website_inp_url_inp',
  btn: false,
  error: false,
}

class RegURL extends React.Component {
  constructor(props){
    super(props)
    this.state = initialState;
  }
componentDidMount() {
  this.setState({
    url: store.getState().website.url
  })
}
changetoReg = () => {
  if(
    this.state.check === 'website_inp_url_inp success'
    )
  {
    this.props.onRouteChange('register')
  }
  else
  {
    this.setState({error: true})
  }
}
addwebsiteUrl = (e, url) => {
this.setState({url: e.target.value.toLowerCase().replace(/\s/gi,"")})
const wurl = e.target.value.toLowerCase().replace(/\s/gi,"")
  if(wurl === '')
{
  this.setState({
    check: 'website_inp_url_inp'
  })
}
else
{
this.checkurl()
}
}

checkurl = (e) => {
  let wurl = null
  if(e) {
    wurl = e.target.value.toLowerCase()
  }
  else wurl = this.state.url
  if(wurl !== store.getState().website.url || this.state.check === 'website_inp_url_inp')
  {
  fetch(`${process.env.REACT_APP_API}/valid`, {
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      url: wurl 
    })
  })
  .then(response => {
    response.json()
    .then(data=> {
      if(data.url==='valid')
      {
      this.props.websiteurl(wurl)
      this.setState({
        check: 'website_inp_url_inp success',
        btn: true
        })
      }
      else
      {
        this.setState({
          check: 'website_inp_url_inp err'
        })
      }
    })
  })
  }
}
render() {
const changeTemplate = (theme) => {
  if(this.state.template === theme)
  {
    this.props.template('')
    this.setState({template: ''})
  }
  else {
    this.props.template(theme)
    if(theme === 'first') {
      this.props.onCustomization([
        {font: "Open Sans", size: "20", color: "#ffffff", class: "profile_name"},
        {font: "Open Sans", size: "16", color: "#f5a623", class: "profile_bio"},
        {font: "Open Sans", size: "18", color: "#ffffff", class: "about"},
        {color: "#fff", class: "icons"},
        {color: "#000000", opacity: "1", class: "background"}
        ])
    }
    else if(theme === 'second') {
      this.props.onCustomization([
        {font: "Open Sans", size: "20", color: "#ffffff", class: "profile_name"},
        {font: "Open Sans", size: "16", color: "#f5a623", class: "profile_bio"},
        {font: "Open Sans", size: "18", color: "#ffffff", class: "about"},
        {color: "#fff", class: "icons"},
        {color: "#0056b5", opacity: "0.4", class: "background"}
        ])
    }
    else if(theme === 'third') {
      this.props.onCustomization([
        {font: "Open Sans", size: "20", color: "#ffffff", class: "profile_name"},
        {font: "Open Sans", size: "16", color: "#f5a623", class: "profile_bio"},
        {font: "Open Sans", size: "18", color: "#ffffff", class: "about"},
        {color: "#fff", class: "icons"},
        {color: "#0056b5", opacity: "0.4", class: "background"}
        ])
    }
    this.setState({template: theme})
  }
}
if(this.state.url) {
  this.checkurl()
}
  let err_msg = null
  if(this.state.error === true) {
    err_msg = <div className="save">
              <div className="save_error">
              <span
              onClick={()=>this.setState({error:false})} href="#" className="close"/>
              Error: Type your profile URL
              </div>
              </div>
  }
      return (
        <div className="form_bg url_bg">
          <Helmet>
            <title>Create Profile Site</title>  
          <meta name="description" content="Start creating your profile site by picking a stunning theme" />
          <meta name="keyword" content="create profile site, free website profile, create vieww profile, create profiles fast" />
          </Helmet>
          <Link to={'/'} href='#' className="close closepanel"/>
        {err_msg}

          <div className="area" >
            <ul className={this.state.check === 'website_inp_url_inp' ? 'circles' : this.state.check === 'website_inp_url_inp success' ? 'circles circles_green' : 'circles circles_red'}>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
            </ul>
          </div>
          <Grid>
          <Row className="fullpage_theme">
          <span href='#' className="go_back go_back_b" onClick={(route)=>this.props.onRouteChange(store.getState().website.template)}/>
          <Col lg={12} md={12} sm={12} xs={12}>
            <h3 className="temp_headings black_color">Profile URL</h3>
            </Col>
            <Col lg={12} md={12} sm={12} xs={12}>
            <div className="hl_btn_container website_box">
             <div className="website_inp_url">
             <div className="website_inp_url_inside">
           <FormControl
            spellcheck="false" 
            autocomplete="off"
            type="text" 
            className={this.state.check}
            name="profileurl" 
            autoCapitalize="off"
            autoCorrect="off"
            placeholder="jon" 
            value={this.state.url}
            onChange={this.addwebsiteUrl}
            /></div>.vieww.me</div>
           </div>
          </Col>
          <Col className="create_btn">
          <button className="btn_new" onClick={this.changetoReg}>Register</button>
          </Col>
          </Row>
          </Grid>

      </div>
      );
}

}
export default RegURL;